export interface Category {
  id: number;
  key: string;
  name: string;
  nameRu: string;
  url: string;
}

export const categories: Category[] = [
  { id: 1, key: 'shoes', name: 'Shoes', nameRu: 'Обувь', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { id: 2, key: 'hoodies', name: 'Hoodies/Sweaters', nameRu: 'Худи и свитера', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { id: 3, key: 'tshirts', name: 'T-Shirts', nameRu: 'Футболки', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { id: 4, key: 'jackets', name: 'Jackets', nameRu: 'Куртки', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { id: 5, key: 'pants', name: 'Pants/Shorts', nameRu: 'Штаны и шорты', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { id: 6, key: 'headwear', name: 'Headwear', nameRu: 'Головные уборы', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { id: 7, key: 'sets', name: 'Sets', nameRu: 'Комплекты', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { id: 8, key: 'underwear', name: 'Underwear/Underpants', nameRu: 'Нижнее бельё', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { id: 9, key: 'jersey', name: 'Jersey', nameRu: 'Джерси', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { id: 10, key: 'accessories', name: 'Accessories', nameRu: 'Аксессуары', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { id: 11, key: 'bags', name: 'Bags', nameRu: 'Сумки', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { id: 12, key: 'belts', name: 'Belts', nameRu: 'Ремни', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { id: 13, key: 'perfumes', name: 'Perfumes', nameRu: 'Парфюмерия', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { id: 14, key: 'other', name: 'Other Stuff', nameRu: 'Разное', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];

export const popularCategories: Category[] = [
  categories[0], // Shoes
  categories[1], // Hoodies
  categories[2], // T-Shirts
  categories[9], // Accessories
  categories[10], // Bags
  categories[3], // Jackets
];

export const footerColumns = [
  {
    title: 'Обувь и одежда',
    items: [categories[0], categories[1], categories[2], categories[3]],
  },
  {
    title: 'Низ и комплекты',
    items: [categories[4], categories[6], categories[7], categories[8]],
  },
  {
    title: 'Аксессуары',
    items: [categories[5], categories[9], categories[10], categories[11]],
  },
  {
    title: 'Другое',
    items: [categories[12], categories[13]],
  },
];